import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import SearchUI from '../../../widgets/input/SearchUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import LinkWithSpinnerUI from '../../../widgets/action/LinkWithSpinnerUI'


const PendingTxnListUI = ({ context, transactionList, onRefreshClick, onDownloadClick,
  onDeclineClick, declineSubmitted, onApproveClick, approveSubmitted,
  deleteMode, onDeleteClick, onCancelDelete, selectedTxnId,
  searchFilter, onSearchFilterChange, onCopyToClipboard, copyToClipboardText,
  showDetails, onShowDetails, selectedReferenceId, eventList, totalAmountF1, subtotalsByTypeBadge, onDownloadTotalBadgeType
}) => {
  return (
    <div className='su_accs'>
      <LRTableActionsUI location='top'
        left={
          <ActionLeftUI
            context={context}
            onRefreshClick={onRefreshClick}
            onDownloadClick={onDownloadClick}
            onDownloadTotalBadgeType={onDownloadTotalBadgeType}
          />
        }
        right={
          <ActionRightUI
            context={context}
            searchFilter={searchFilter}
            onSearchFilterChange={onSearchFilterChange}
          />
        }
      />

      <div className='g_flex_h g_m_bottom_50'>
        <span className='g_muted g_small'>Payments to be approved in ICICI CMS console</span>
        <span>{transactionList.length} transaction{transactionList.length == 1 ? '' : 's'} displayed</span>
      </div>

      <div>
        <table className='g_table'>
          <thead>
            <tr>
              <th className='g_small'>Type Badge</th>
              <th className='g_small'>Total</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(subtotalsByTypeBadge).map(([typeBadge, total], idx) => (
              <tr key={idx}>
                <td className='g_small'>{typeBadge}</td>
                <td className='g_text_right'>{total}</td>
              </tr>
            ))}
            {/* Total transcation amount Row */}
            <tr>
              <td className='g_small'><strong>Total Transaction Amount</strong></td>
              <td className='g_text_right'>
                <b>{totalAmountF1}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <LRTableBodyUI className='g_m_top_50'>
        {
          transactionList.map((txn, i) =>
            <TxnRowList key={i} context={context} txn={txn}
              onDeclineClick={onDeclineClick} declineSubmitted={declineSubmitted}
              onApproveClick={onApproveClick} approveSubmitted={approveSubmitted}
              deleteMode={deleteMode} onDeleteClick={onDeleteClick} onCancelDelete={onCancelDelete}
              selectedTxnId={selectedTxnId}
              onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
              showDetails={showDetails} onShowDetails={onShowDetails} selectedReferenceId={selectedReferenceId} eventList={eventList}
            />
          )
        }
      </LRTableBodyUI>
    </div>
  );
}

const TxnRowList = ({ context, txn,
  onDeclineClick, declineSubmitted, onApproveClick, approveSubmitted,
  deleteMode, onDeleteClick, onCancelDelete, selectedTxnId,
  onCopyToClipboard, copyToClipboardText, showDetails, onShowDetails, selectedReferenceId, eventList
}) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={<RowLeftUI context={context} txn={txn}
      onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText} selectedTxnId={selectedTxnId}
      showDetails={showDetails} onShowDetails={onShowDetails} selectedReferenceId={selectedReferenceId} eventList={eventList}
    />}
    right={<RowRightUI context={context} txn={txn}
      onDeclineClick={onDeclineClick} declineSubmitted={declineSubmitted}
      onApproveClick={onApproveClick} approveSubmitted={approveSubmitted}
      deleteMode={deleteMode} onDeleteClick={onDeleteClick} onCancelDelete={onCancelDelete}
      selectedTxnId={selectedTxnId} />}
  />

const RowLeftUI = ({ context, txn, onCopyToClipboard, copyToClipboardText, showDetails, onShowDetails, selectedReferenceId, eventList, selectedTxnId }) =>
  <div className='g_flex_v'>
    <span className=''>
      {txn.transactionDateF}
      <span className='g_muted g_m_left_50'>{txn.transactionId}</span>
      <span onClick={e => e.stopPropagation()}>
        <CopyToClipboard text={txn.transactionId}
          onCopy={onCopyToClipboard}>
          <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
        </CopyToClipboard>
        {
          copyToClipboardText === txn.transactionId &&
          <span className='g_m_left_50 g_muted'>copied</span>
        }
      </span>
    </span>
    <span className='g_m_top_25'>
      <BadgeUI label={txn.typeBadge} />
      <span className='g_m_left_50'><b>{txn.accountName}</b></span>
      {
        txn.remitter &&
        <span className='g_m_left_50 icon icon-angle-left'> {txn.remitter}</span>
      }
      {
        txn.payee &&
        <span className='g_m_left_50 icon icon-angle-right'> {txn.payee}</span>
      }
    </span>
    <span className='g_flex_h g_flex_left g_m_top_25 g_small'>
      <span>{txn.bankAccountNumber}</span>
      <span className='g_m_left_100'>Vert Ref Id:</span>
      <LinkWithSpinnerUI className='g_m_left_25' label={txn.referenceId} spinnerOnLeft={false}
        onClick={onShowDetails} busy={showDetails && selectedReferenceId === txn.referenceId}
        rowId={txn.referenceId + '_' + txn.transactionId}
      />
    </span>
    {
      selectedReferenceId === txn.referenceId && selectedTxnId === txn.transactionId && eventList && !eventList.length &&
      <div>No events yet</div>
    }
    {
      selectedReferenceId === txn.referenceId && selectedTxnId === txn.transactionId && eventList && eventList.map((event, i) =>
        <div className='g_flex_v' key={i}>
          <span>{event.dateCreatedF1}</span>
          <span>{event.record}</span>
        </div>
      )
    }

  </div>


const RowRightUI = ({ context, txn, onDeclineClick, declineSubmitted, onApproveClick, approveSubmitted,
  deleteMode, onDeleteClick, onCancelDelete, selectedTxnId }) =>
  <div className='g_flex_v g_text_right'>
    <span>{txn.amountF1}</span>
    {
      txn.tdsAmountF2 &&
      <span className='g_muted'>TDS {txn.tdsSection} @{txn.tdsRate}% {txn.tdsAmountF2}</span>
    }
    {/*
        bill.taxList.map((tax, j) =>
          <tr key={j}>
            <td className='g_no_wrap_2'>{tax.name}</td>
            <td className='g_text_right'>{tax.amountF2}</td>
          </tr>
        )
      */}

    {
      txn.testAccount &&
      <span className='g_flex_h g_m_top_25'>
        <SpinnerUI show={declineSubmitted && selectedTxnId === txn.transactionId} reserveSpace={true} />
        <ButtonTinyUI label='Decline' rowId={txn.transactionId} onClick={onDeclineClick} />
        <span className='g_m_left_50' />
        <SpinnerUI show={approveSubmitted && selectedTxnId === txn.transactionId} reserveSpace={false} />
        <ButtonTinyUI label='Approve' rowId={txn.transactionId} onClick={onApproveClick} />
      </span>
    }

    {
      context.permissions.includes('su_superuser_business') &&
      <span className='g_m_top_25 g_text_right'>
        <ButtonTinyUI label='Delete' rowId={txn.transactionId} onClick={onDeleteClick} />
      </span>
    }
  </div>

const ActionLeftUI = ({ context, onRefreshClick, onDownloadClick, onDownloadTotalBadgeType }) =>
  <span className='g_flex_left g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <IconButtonUI icon='icon-download' onClick={onDownloadClick} />
    <IconButtonUI icon='icon-download' onClick={onDownloadTotalBadgeType} label='Download Total Badge Type' />
    <span className='g_m_left_100 g_large'><b>Pending Approval in Escrow Accounts</b></span>
  </span>

const ActionRightUI = ({ context, messageList, searchFilter, onSearchFilterChange }) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default PendingTxnListUI
